export default {
  //API_BASE_URL: "http://localhost:3454/serit",
  API_BASE_URL: "https://serit.planner.dev.filcronet.it/serit",
  //API_BASE_URL: "http://planner.serit.info/serit",
  LOGIN_USERNAME: "admin_srt",
  LOGIN_PASSWORD: "RsSoX0v78GA0",
  SLIDESHOW_DURATION_SECONDS: 10,
  PAGE_DISPLAY_TIME_MS: 5000,
  SERVIZI_PER_PAGINA: 9
}